// Registers the Sentry breadcrumb/event transport into the logger.
// Must run *after* initSentry so the Sentry SDK is ready when the transport
// starts writing. Console transport is always registered eagerly in logger.ts.

import { flags } from '@core/config'
import { registerTransport, sentryTransport } from '@core/logging'

export const initLogger = (): void => {
  if (flags.sentryEnabled) registerTransport(sentryTransport)
}
